import { Modal } from '@/shared/components/Modal';

interface FinishConfirmModalProps {
  open: boolean;
  answeredCount: number;
  totalCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * "Deseja mesmo finalizar?", antes do cadastro.
 *
 * Existe porque finalizar **encerra o ensaio**: depois do envio as respostas
 * viram resultado e não se editam mais. O diálogo diz quantas ficaram em
 * branco, que é a informação que muda a decisão — quem esqueceu três questões
 * para trás quer voltar, não descobrir no diagnóstico.
 */
export function FinishConfirmModal({
  open,
  answeredCount,
  totalCount,
  onCancel,
  onConfirm,
}: FinishConfirmModalProps) {
  const blank = totalCount - answeredCount;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      role="alertdialog"
      title="Finalizar o ensaio?"
      note={
        <>
          Você respondeu {answeredCount} de {totalCount} questões.{' '}
          {blank > 0 && (
            <strong>
              {blank === 1
                ? '1 questão ficou em branco e conta como erro. '
                : `${blank} questões ficaram em branco e contam como erro. `}
            </strong>
          )}
          Depois de finalizar, não dá para mudar as respostas.
        </>
      }
    >
      <div className="modal-actions">
        <button type="button" className="ghost ghost-lg" onClick={onCancel}>
          Continuar respondendo
        </button>
        <button
          type="button"
          className="cta cta-inline cta-block"
          onClick={onConfirm}
        >
          Finalizar
        </button>
      </div>
    </Modal>
  );
}
